import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiRequestService } from '../../http/api-request.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { CommonUtilty } from 'app/BaseFramework';


@Injectable({
  providedIn: 'root'
})
export class UiBuilderService {

  constructor(private apiRequest: ApiRequestService,
    private http: HttpClient,
    private commonUtilty: CommonUtilty) { }

  fetchUIConfigurationByGuid(guid): Observable<any> {
    /*let uiConfigSubject = new Subject<any>();
    this.apiRequest.get('config/ui/fetch-config-guid/' + guid)
      .subscribe(jsonResp => {
        uiConfigSubject.next(jsonResp);

      },errResp => {
        uiConfigSubject.next(errResp);
      })
    return uiConfigSubject;*/
    let fetchedResult = new Subject<any>();

    const headers = { 'Content-Type': 'application/json' };
    this.http.get<any>(environment['lowCodeHost'] + "/fetchByGuid?guid="+ guid , { headers })
      .subscribe(jsonResp => {
        let returnObj = this.commonUtilty.deepCopy(jsonResp);
        fetchedResult.next(returnObj);
      }, err => {
        fetchedResult.next(err);
      });

    return fetchedResult;
  }

  fetchUIConfigurationByCriteria(payload){
    let fetchConfig = new Subject<any>();
    const headers = { 'Content-Type': 'application/json' };

    this.http.post<any>(environment['lowCodeHost'] + "/fetchConfigurationBasedOnCriteria", payload, { headers })
        .subscribe(jsonResp => {
            let returnObj = this.commonUtilty.deepCopy(jsonResp);
            fetchConfig.next(returnObj);
        },err => {
          fetchConfig.next(err);
      });

    return fetchConfig;
  }

  fetchUIConfigurationByJSONBin(guid: any): Observable<any> {
    let uiConfigSubject = new Subject<any>();

    const headers = { 
      'Content-Type': 'application/json',
      'X-Master-Key': '$2b$10$o.lzdHKCni1z07MCo2VCLOK5VVdZwXhs9fhvKjqKIlCsfwiFauR9G'
     };
    this.http.get<any>('https://api.jsonbin.io/v3/b/'+guid, { headers })
        .subscribe(jsonResp => {
            uiConfigSubject.next(jsonResp);
        });
        
    return uiConfigSubject;
}
}
